import jamespot, { WidgetLuccaAbsenceUser } from 'jamespot-user-api';
import { useEffect, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { useAbortController } from '../../../hooks';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';
import { WidgetHeader } from './components/WidgetHeader';
import { WidgetScroll } from './components/WidgetScroll';
import { WidgetStylePadding } from './components/WidgetStylePadding';

export const UIOverlay = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const WidgetLuccaAbsence = commonComponentsRegistry.getLazyComponent('WidgetLuccaAbsence');
const JRCLoader = commonComponentsRegistry.getLazyComponent('Loader');

export const JRCWidgetLuccaAbsenceWrapper = ({ uniqid }: { uniqid: string }) => {
    const [list, setList] = useState<WidgetLuccaAbsenceUser[]>([]);
    const [error, setError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const abortController = useAbortController();

    const today = useMemo(() => {
        return (
            new Date().getFullYear() +
            '-' +
            (new Date().getMonth() + 1).toString().padStart(2, '0') +
            '-' +
            new Date().getDate().toString().padStart(2, '0') +
            ' 00:00:00'
        );
    }, []);

    useEffect(() => {
        jamespot.lucca
            .getAbsence({ date: today }, { signal: abortController.signal })
            .then(({ result }) => setList(result))
            .catch(() => {
                if (!abortController.signal.aborted) {
                    setError(true);
                }
            })
            .finally(() => setIsLoading(false));
    }, [today, abortController.signal]);

    if (isLoading) {
        return (
            <UIOverlay>
                <JRCLoader size={'m'} />
            </UIOverlay>
        );
    }

    if (error) {
        return (
            <UIOverlay>
                <FormattedMessage id={'WIDGET_Lucca_Absence_Url_Error'} />
            </UIOverlay>
        );
    }

    return (
        <WidgetScroll
            header={() => {
                return <WidgetHeader uniqid={uniqid} />;
            }}
            scrollable={() => {
                return (
                    <WidgetStylePadding uniqid={uniqid}>
                        <WidgetLuccaAbsence list={list} />
                    </WidgetStylePadding>
                );
            }}
        />
    );
};
